import React, {Component} from 'react';

class Contacts extends Component {
    constructor() {
        super()
        this.state = {
            name: '',
            email: '',
            subject: '',
            message: ''
        }
        this.handleChange = this.handleChange.bind(this)
    }

    handleChange = e => {
        this.setState({[e.target.name]: e.target.value})
    }

    submitForm = e => {
        // preventDefault(e)
    }

    render(){
        // const {name, email, subject, message, emailStatus} = this.state;
        return(
            <section className="contact_info_area sec_pad bg_color">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6">
                            <div className="contact_info_item">
                                <h6 className="f_p f_size_20 t_color3 f_500 mb_20">Address</h6>
                                <p className="f_400 f_size_15">49, Jayaweera mw, Ethul Kotte, Kotte</p>
                            </div>
                            <div className="contact_info_item">
                                <h6 className="f_p f_size_20 t_color3 f_500 mb_20">Team Contact Info</h6>
                                <p className="f_400 f_size_15"><span className="f_400 t_color3">Email:</span> <a href="mailto:backslash.info.help@gmail.com" target="_blank" rel="noopener noreferrer">backslash.info.help@gmail.com</a></p>
                            </div>
                            <div className="contact_info_item">
                                <h6 className="f_p f_size_20 t_color3 f_500 mb_20">Supervisor Contact Info</h6>
                                Ms. Disni Sriyaratna
                                <p className="f_400 f_size_15"><span className="f_400 t_color3">Email:</span> <a href="mailto:disni.s@sliit.lk" target="_blank" rel="noopener noreferrer">disni.s@sliit.lk</a></p>
                                Dr. Dharshana Kasthurirathna
                                <p className="f_400 f_size_15"><span className="f_400 t_color3">Email:</span> <a href="mailto:dharshana.k@sliit.lk" target="_blank" rel="noopener noreferrer">dharshana.k@sliit.lk</a></p>
                            </div>

                        </div>
                        <div className="col-lg-6">
                            <div className="contact_info_item">
                                <h6 className="f_p f_size_20 t_color3 f_500 mb_20">Members Contact Info</h6>
                                Viraj Konthasinghe
                                <p className="f_400 f_size_15"><span className="f_400 t_color3">Phone:</span> <a href="tel:0779321995" target="_blank" rel="noopener noreferrer">(+94) 77 932 1995</a></p>
                                <p className="f_400 f_size_15"><span className="f_400 t_color3">Email:</span> <a href="mailto:virajkonthasinghe@gmail.com" target="_blank" rel="noopener noreferrer">virajkonthasinghe@gmail.com</a></p>
                                Kavindi Gunasinghe
                                <p className="f_400 f_size_15"><span className="f_400 t_color3">Phone:</span> <a href="tel:0779321995" target="_blank" rel="noopener noreferrer">(+94) 77 305 8210</a></p>
                                <p className="f_400 f_size_15"><span className="f_400 t_color3">Email:</span> <a href="mailto:uldkavindigunasinghe@gmail.com" target="_blank" rel="noopener noreferrer">uldkavindigunasinghe@gmail.com</a></p>
                                Senura Diwantha
                                <p className="f_400 f_size_15"><span className="f_400 t_color3">Phone:</span> <a href="tel:0779321995" target="_blank" rel="noopener noreferrer">(+94) 77 264 6888</a></p>
                                <p className="f_400 f_size_15"><span className="f_400 t_color3">Email:</span> <a href="mailto:senuradiwantha900@gmail.com" target="_blank" rel="noopener noreferrer">senuradiwantha900@gmail.com</a></p>
                                Hiruni Malaviarachchi
                                <p className="f_400 f_size_15"><span className="f_400 t_color3">Phone:</span> <a href="tel:0779321995" target="_blank" rel="noopener noreferrer">(+94) 77 407 0057</a></p>
                                <p className="f_400 f_size_15"><span className="f_400 t_color3">Email:</span> <a href="mailto:mail2hiruni@gmail.com" target="_blank" rel="noopener noreferrer">mail2hiruni@gmail.com</a></p>
                            </div>
                        </div>
                    </div>

                </div>
            </section>
        )
    }
}

export default Contacts;
